import React, { useCallback, useState } from "react";
import { Plus } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AddProductToCategoryDialog from "./AddProductToCategoryDialog";
import { refreshCategoryListing } from "./addProductToCategoryUtils";

const CategoryAddProductButton = ({
  categorySlug,
  categoryId,
  categoryName,
  categoryLevel,
  isFamily = false,
  onSuccess,
  className = "icon-button category-group__add-product-btn",
  iconSize = 20,
  stopPropagation = false,
}) => {
  const dispatch = useDispatch();
  const { id: pageCategorySlug } = useParams();
  const stationId = useSelector((state) => state.user.stationId);
  const role = useSelector((state) => state.user.role);
  const isClientView = useSelector((state) => state.category.isClientView);
  const includeInactive = useSelector(
    (state) => state.category.includeInactive,
  );
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleSuccess = useCallback(() => {
    if (onSuccess) {
      onSuccess();
      return;
    }
    refreshCategoryListing({
      dispatch,
      stationId,
      categoryPageSlug: pageCategorySlug,
      role,
      isClientView,
      includeInactive,
    });
  }, [
    dispatch,
    stationId,
    pageCategorySlug,
    role,
    isClientView,
    includeInactive,
    onSuccess,
  ]);

  if (!categorySlug) return null;

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={(event) => {
          if (stopPropagation) {
            event.preventDefault();
            event.stopPropagation();
          }
          setDialogOpen(true);
        }}
        onMouseDown={(event) => {
          if (stopPropagation) event.stopPropagation();
        }}
        aria-label={`הוסף מוצר ל${categoryName || "קטגוריה"}`}
        title="הוסף מוצר"
      >
        <Plus size={iconSize} strokeWidth={2} aria-hidden />
      </button>
      <AddProductToCategoryDialog
        isOpen={dialogOpen}
        onClose={() => setDialogOpen(false)}
        categorySlug={categorySlug}
        categoryId={categoryId}
        categoryName={categoryName}
        categoryLevel={categoryLevel}
        isFamily={isFamily}
        onSuccess={handleSuccess}
      />
    </>
  );
};

export default CategoryAddProductButton;
